import Repository from './Repository';
import ListRequest from '@/models/ListRequest';
import {ModifyIngredientCostDto} from "@/models/RecipeInvoice/ModifyIngredientCostDto";
import {Vendor} from "@/models/IngredientCost/Vendor";
import {AxiosResponse} from "axios";
import {ListResult} from "@/utils/API/ResultTypes/ListResult";

const resource = '/ingredientCosts';

export default {
  listIngredientCost(listRequest: ListRequest) {
    return Repository.post(`${resource}/ListIngredientCosts`, listRequest, { withCredentials: true });
  },
  listIngredientCostVendors() {
    return Repository.get(`${resource}/ListIngredientCostVendors`, { withCredentials: true });
  },
  createIngredientCosts(ingredientCosts: ModifyIngredientCostDto[]) {
    return Repository.post(`${resource}/CreateIngredientCosts`, { ingredientCosts: ingredientCosts }, { withCredentials: true });
  },
  createIngredientCostVendor(name: string): Promise<AxiosResponse<ListResult<Vendor>>> {
    return Repository.post(`${resource}/CreateIngredientCostVendor`, { name: name }, { withCredentials: true });
  },
  updateIngredientCost(ingredientCost: ModifyIngredientCostDto) {
    return Repository.post(`${resource}/UpdateIngredientCost`, ingredientCost, { withCredentials: true });
  },
  deleteIngredientCost(id: number) {
    return Repository.post(`${resource}/DeleteIngredientCost`, { id: id }, { withCredentials: true });
  },
  uploadIngredientCosts(formData: FormData) {
    return Repository.post(`${resource}/UploadIngredientCosts`, formData, { withCredentials: true });
  },
  loadMeasurementsForIngredientCost(data: any) {
    return Repository.post(`${resource}/LoadMeasurementsForIngredientCost`, data, { withCredentials: true });
  }
};
